
export default {
  ADD_DEMO: '/carrier/user/add_demo'
}
